var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#EDAD0C",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_274_855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 19C15.8463 19 15.6993 18.937 15.5935 18.826L11.656 14.701C11.3148 14.344 11.5683 13.75 12.0625 13.75H14.125V9.4375C14.125 8.92075 14.5458 8.5 15.0625 8.5H16.9375C17.4543 8.5 17.875 8.92075 17.875 9.4375V13.75H19.9375C20.4318 13.75 20.6853 14.344 20.344 14.701L16.4065 18.826C16.3008 18.937 16.1538 19 16 19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6875 23.5H8.3125C7.58875 23.5 7 22.9113 7 22.1875V21.8125C7 21.0888 7.58875 20.5 8.3125 20.5H23.6875C24.4112 20.5 25 21.0888 25 21.8125V22.1875C25 22.9113 24.4112 23.5 23.6875 23.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_274_855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon_download.66dcbfd176f699c0ad74ac9ccb7f5605.svg";
export { ForwardRef as ReactComponent };